import React from 'react';
import PropTypes from 'prop-types';

const Switch = ({ options, className, hasError, errormessage, isChecked, onChange, ...rest }) => (
  <div className="form-group">
    <label className="switch">
      <input
        type="checkbox"
        value={isChecked}
        onChange={onChange}
        {...rest}
      />
      <span className="slider" />
      {
        options.map((item, index) => (<span className={`option${index + 1}`} key={index}>{item}</span>))
      }
    </label>
  </div>
);

Switch.propTypes = {
  hasError: PropTypes.bool,
  errormessage: PropTypes.string,
  isChecked: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
};

Switch.defaultProps = {
  className: '',
  isChecked: '',
  hasError: false,
  errormessage: '',
  onChange: () => {},
};

export default Switch;
